// Season configuration and history data.
//
// Each src/seasons/<year>.js file is a plain serializable object: static
// format rules plus, for finished seasons, a `results` block. This loader is
// the only place the rest of the app gets season data from — if pals ever
// bring their own leagues, getSeasonConfig grows a Supabase lookup with these
// files as the fallback, and nothing downstream changes.
import season2023 from './2023';
import season2024 from './2024';
import season2025 from './2025';
import season2026 from './2026';

const SEASONS = {
  2023: season2023,
  2024: season2024,
  2025: season2025,
  2026: season2026,
};

export const getSeasonConfig = (season) => SEASONS[season] || null;

/**
 * How many teams are eliminated in a matchup week: none before the season's
 * elimination start week, one by default after it, or a week override (the
 * double-elimination weeks).
 */
export const eliminationsForWeek = (config, week) => {
  if (!config?.eliminationStartWeek || week < config.eliminationStartWeek) return 0;
  return config.weekOverrides?.[week]?.eliminations ?? 1;
};

/** Every season config, newest first. */
export const allSeasons = () =>
  Object.values(SEASONS).sort((a, b) => b.season - a.season);

/**
 * Which face the homepage shows. 'danger' and 'playoffs' arrive with the
 * elimination build; until then anything after week 1 kickoff is 'inSeason'.
 */
export function getPhase(config, now = new Date()) {
  if (config?.weekOneKickoff && now < new Date(config.weekOneKickoff)) {
    return 'preseason';
  }
  return 'inSeason';
}

// Hand-curated record book and hall of shame for the History page. Null
// values render as "TBD" — fill them in as the numbers get tallied from the
// season archives. `holder` is a team or manager name; `detail` is the small
// print under it.
export const RECORD_BOOK = [
  { title: 'Most season points', holder: 'Donkey Teeth', detail: '2023', value: '1,430.58' },
  { title: 'Best finals total', holder: 'VanceInYourPants', detail: '2023', value: '280.78' },
  { title: 'Highest single week', holder: null, detail: 'to be tallied', value: null },
  { title: 'Playoff appearances', holder: null, detail: 'to be tallied', value: null },
  { title: 'All-time points', holder: null, detail: 'to be tallied', value: null },
];

export const HALL_OF_SHAME = [
  { title: 'All-time least points', holder: null, detail: 'to be tallied', value: null },
  { title: 'All-time least games played', holder: null, detail: 'to be tallied', value: null },
];
